import type { ScreenWakePort } from '@Domain/Ports/ScreenWake/ScreenWakePort';
import PortsContext from '@UI/Providers/PortsProvider/PortsContext';
import * as React from 'react';

function useScreenWakePort(): ScreenWakePort {
	const context = React.useContext(PortsContext);

	if (context === null) {
		throw new Error('useScreenWakePort doit être utilisé à l’intérieur d’un PortsProvider.');
	}

	return context.screenWake;
}

export default useScreenWakePort;
